// @ts-ignore
import { Environment } from '@elight/client/shared/utility/common';

class LocalEnvironment implements Environment {
    production = false;
    development = false;
    api = {
        baseURL: 'https://staging.api.app.elight.com/api',
    };
    firebase = {
        apiKey: 'AIzaSyAPvjMETz4zwnlu-nsGNrPL5FEncynvG1s',
        authDomain: 'elight-dev-57808.firebaseapp.com',
        databaseURL: 'https://elight-dev-57808.firebaseio.com',
        projectId: 'elight-dev-57808',
        storageBucket: 'elight-dev-57808.appspot.com',
        messagingSenderId: '437776397702',
        appId: '1:437776397702:web:917c426e2412625363e807',
        backofficeURL: 'https://staging.audit.elight.com',
    };
}
export const environment = new LocalEnvironment();
